import { FormGroup } from "@angular/forms";
import { OrderWizardService } from "../../../_service/order-wizard.service";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CorpRangeBarComponent } from "@corporate-tailwind/component";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: 'order-purchase-summary-alert',
    imports: [CommonModule, CorpRangeBarComponent, TranslateModule],
    templateUrl: './order-purchase-summary-alert.component.html',
    styleUrls: ['./order-purchase-summary-alert.component.scss']
})
export class OrderPurchaseSummaryAlertComponent implements OnInit, OnDestroy {
    form: FormGroup | null = null;

    constructor(
        public _orderWizardService: OrderWizardService,
    ) {
        this.form = this._orderWizardService.formGroup;
    }

    ngOnInit(): void {

    }

    ngOnDestroy(): void {
  
    }


}